/**
 * This file is used to provide the translation loader for the application.
 * It has been adapted from this GitHub Issue: Support for Angular v18
 * - https://github.com/ngx-translate/core/issues/1481
 */

import { HttpBackend } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';

function HttpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, [{ prefix: './assets/i18n/', suffix: '.json' }]);
}
export const provideTranslation = () => ({
  loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpBackend],
  },
});
